import PropTypes from "prop-types";
import React, { useMemo } from "react";

import { classNames } from "@swa-ui/string";

import styles from "./HtmlValue.module.scss";

export const HtmlValue = (props) => {
  const { className, htmlValue, inline = false } = props;
  const Component = useMemo(() => (inline ? "span" : "div"), [inline]);

  return (
    <Component
      className={classNames(styles.htmlValue, className)}
      dangerouslySetInnerHTML={{ __html: htmlValue }}
    />
  );
};

HtmlValue.displayName = "HtmlValue";
HtmlValue.propTypes = {
  /** Classes for styling. */
  className: PropTypes.string,

  /** Raw HTML string to be rendered. */
  htmlValue: PropTypes.string,
};
